module.exports = __webpack_public_path__ + "static/iphone3.6238ce9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iphone3.png
// module id = 531
// module chunks = 54681204059826